export const SCREEN_WIDTH = {
  small: 800,
  medium: 1312,
  large: 1650,
};
